// Fondo marino (footer de Home/About). Todo lo ajustable vive aquí.
// Es un TERRENO 3D real visto en perspectiva rasante (la cámara mira en horizontal): arena con dunas y
// ondulaciones, unas pocas rocas, niebla submarina con la distancia y los reflejos de la superficie (caustics).

export const SEABED_SETTINGS = {
  // ── POSICIÓN / ENTRADA ──
  floorY: 0.36,            // profundidad del suelo bajo el ojo de la cámara (× alto de pantalla). ↑ = suelo más abajo
  pitchPortrait: 3,        // ídem en pantallas verticales (móvil)
  pitch: 5.5,                // grados que se inclina la vista hacia el suelo (↑ = el suelo ocupa más pantalla, horizonte más alto)
  rise: 2,                 // cuánto "sube" el fondo al llegar (× px de scroll que faltan). ↑ = aparece antes
  duneAmp: 150,             // altura de las dunas (px de mundo en z=0; crece con la distancia)
  duneScale: 1,            // ↑ = dunas más pequeñas/frecuentes

  mobileDim: 0.62,         // oscurecido global del fondo en móvil (1 = igual que desktop)

  // ── ARENA ──
  sandLit: '#153258',      // arena iluminada desde la superficie
  sandDark: '#050b20',     // arena en sombra
  ripple: 0.35,            // intensidad de las ondulaciones de arena (0 = lisa)

  // ── ROCAS ──
  rockDark: '#070d26',     // piedra en sombra
  rockLight: '#2c4880',    // piedra iluminada
  rim: '#5a9ee0',          // luz de borde
  surfaceLight: '#4f93e0', // luz que baja desde la superficie
  // Cada roca se define por su sitio EN PANTALLA: sx (-0.5…0.5 × ancho), d (distancia a cámara, px),
  // size (alto en pantalla × alto de pantalla), squash (alto/ancho), rot (giro).
  rocks: [
    { sx: 0.34,  d: 2600, size: 0.58,  squash: 0.72, rot: 2.1, mobile: false },   // roca enorme (derecha) · no se usa en móvil
    { sx: -0.36, d: 2200, size: 0.34,  squash: 0.7,  rot: 0.6 },   // roca grande (izquierda)
    { sx: 0.0,   d: 4000, size: 0.12,  squash: 0.7,  rot: 4.0 },
    { sx: 0.47,  d: 1900, size: 0.07,  squash: 0.6,  rot: 1.2 },
    { sx: -0.12, d: 3300, size: 0.08,  squash: 0.8,  rot: 5.1 },
    { sx: 0.1,   d: 2000, size: 0.045, squash: 0.6,  rot: 3.3 },
    { sx: -0.2,  d: 1900, size: 0.04,  squash: 0.6,  rot: 0.2 },
  ],
  mobileRocks: 4,          // en móvil se usan solo las N primeras (saltando las marcadas con mobile: false)

  // ── LUZ ──
  lightContrast: 0.9,      // dramatismo: 0 = luz uniforme · 1 = haces muy marcados con zonas en sombra
  frontFill: 0.7,          // luz mínima del suelo cercano a cámara (0 = puede quedar en sombra total · 1 = siempre iluminado)
  lightScale: 0.0009,      // tamaño de los haces/manchas de luz (↑ = más pequeños)

  // ── REFLEJOS DE LA SUPERFICIE (caustics) ──
  causticColor: '#9fdcff',
  causticStrength: 0.16,
  causticScale: 560,       // px de mundo por "tile" del patrón (↑ = patrón más grande)
  causticSpeed: 0.4,

  // ── NIEBLA SUBMARINA (se funde con el color de fondo del 2º render) ──
  fogDensity: 0.0003,      // ↑ = el fondo se pierde antes
  fogPower: 1.5,           // forma de la caída
  farStart: 3600,          // distancia (px) a partir de la que el fondo empieza a oscurecerse (≈ la roca del fondo)
  farEnd: 6500,            // distancia a la que el oscurecimiento es máximo
  farDark: 0.8,            // cuánto se oscurece al llegar a farEnd (0 = nada · 1 = hasta el color del agua)
  haze: '#1a3d8c',         // tinte hacia el que se aclara la niebla
  hazeMix: 0.3,
};
